// @ts-nocheck — TODO: Add proper types (Phase 7)
import { useEffect } from 'react';
import { listenerRegistry } from '@/services/core/listenerRegistry';

/**
 * Hook to cleanup all Firestore listeners when the app unmounts
 * or when switching between major views
 */
export function useCleanupFirestoreListeners(cleanupTrigger) {
  useEffect(() => {
    // Log current listener count on mount
    if (import.meta.env.DEV) {
      // no-op
    }

    return () => {
      // Only cleanup if trigger is true or undefined (default behavior)
      if (cleanupTrigger !== false) {
        const beforeCount = listenerRegistry.getActiveListenerCount();
        
        if (beforeCount > 0 && import.meta.env.DEV) {
          // no-op
        }
        
        // Clear all listeners
        listenerRegistry.clearAll();
        
        if (import.meta.env.DEV) {
          // no-op
        }
      }
    };
  }, [cleanupTrigger]);
}

/**
 * Hook to monitor listener count in development
 */
export function useMonitorListeners(warningThreshold = 50) {
  useEffect(() => {
    if (!import.meta.env.DEV) {
      return;
    }

    const checkListeners = () => {
      const count = listenerRegistry.getActiveListenerCount();
      
      if (count > warningThreshold) {
        console.warn(`High number of Firestore listeners: ${count}`);
        console.table(listenerRegistry.getListenerInfo());
      }
    };

    // Check every 10 seconds
    const interval = setInterval(checkListeners, 10000);

    return () => clearInterval(interval);
  }, [warningThreshold]);
}

export default useCleanupFirestoreListeners;